import React, { useContext, useEffect, useState } from "react";
import AgentFeedbackContainer from "../Feedback/Agent/AgentFeedbackContainer";
import AgentViewContainer from "./AgentViewContainer";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import { APIContext } from "../Contexts/APIContext";
import { MsalContext } from "src/components/Contexts/MsalContext"
import AssessmentIcon from '@mui/icons-material/Assessment';
import FilterBar from "../Filtering/FilterBar";
import { NewIndexViewModel } from "../ViewModels/IndexContainerViewModels";
import Alert from "@mui/material/Alert";
import ReportContainer from "../PowerBIReport/ReportContainer";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import ChallengeQuestionContainer from "../QaiScorecardChallenge/AgentView/ChallengeQuestionContainer";
import UserType from "../Utilities/UserType";
import CallTableViewModel from "../ViewModels/CallTableViewModel";
import Box from "@mui/material/Box";

const styles = {
    selectedTab: {
        borderRadius: 0,
        padddingLeft: '16px',
        paddigRight: '16px',
        borderTop: 'solid 1px black',
        borderLeft: 'solid 1px black',
        borderRight: 'solid 1px black',

    },
    tab: {
        backgroundColor: '#1D8ABF',
        color: '#fff',
        borderRadius: 0,
        borderBottom: 'solid 1px black',
        padddingLeft: '16px',
        paddigRight: '16px',
        '&:hover': {
            backgroundColor: '#1D8ABF'
        }
    }
}
interface Tab {
    id: number;
    name: string;
    todayGuid: string;
    historicGuid: string;
}
interface IAgentViewFeedbackContainerProps {
    callRefId?: string;
    customerId?: string;
    date?: string;
}

const tabs: Tab[] = [
    { id: 0, name: "My Calls", todayGuid: "", historicGuid: "" },
    { id: 1, name: "Q-AI Report", todayGuid: "5ceda21b-54d1-4a32-be36-882dfe6fa86d", historicGuid: "eb96032a-fc2f-45b5-94f1-68a02ab8d07f" },
    { id: 2, name: "My Feedback", todayGuid: "", historicGuid: "" },
    { id: 3, name: "Sales-AI Report", todayGuid: "f40dcfa6-9adf-4c19-adf8-58de6900468c", historicGuid: "6aa09ad5-87dd-4665-b68b-a742f7aa4adb" },

];

export default function AgentViewFeedbackContainer(props: IAgentViewFeedbackContainerProps) {
    const { get } = useContext(APIContext);
    const [index, setIndex] = useState(0);
    const [feedback, setFeedback] = useState(0);
    const { setIsAdmin } = useContext(APIContext);
    const { msalFetch } = useContext(MsalContext);
    const [findingCall, setFindingCall] = useState(false);
    const [callRefId, setCallRefId] = useState<string | null>(null);
    const [showAlert, setShowAlert] = useState(true);
    const [callTableViewModel, setCallTableViewModel] = useState<CallTableViewModel>(new CallTableViewModel());
    const [data, setData] = useState<NewIndexViewModel>(new NewIndexViewModel());
    const [searchFailed, setSearchFailed] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openChallengeDialog, setOpenChallengeDialog] = useState(false);


    useEffect(() => {
        msalFetch('api/User/IsAdmin')
            .then(response => response.json())
            .then(data => {
                setIsAdmin(data);
            });
        getFeedbackCount();
        if (props.customerId != undefined) {
            getFirstCall();
        }
        getAgentData();
        if (props.callRefId) {
            setCallRefId(props.callRefId);
        }
    }, []);

    useEffect(() => {
        setData(new NewIndexViewModel());
    }, [callTableViewModel, showAlert]);

    const filterSearch = (filter: CallTableViewModel) => {
        const oldData = data;
        setLoading(true);
        msalFetch('api/Search/ApplyFilter?isAgentView=true', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(filter)
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setData(data.value);
                    setLoading(false);
                }
                else {
                    setData(oldData);
                    setSearchFailed(true);
                    setLoading(false);
                }
            });
    }

    const filterSearchPageReset = () => {
        setLoading(true);
        const oldData = data;
        msalFetch('api/Search/ApplyFilter?isAgentView=true', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(callTableViewModel)
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setData(data.value);
                    setLoading(false);
                }
                else {
                    oldData.callTableViewModel.filters.pageNumber = 0;
                    setData(oldData);
                    setSearchFailed(true);
                    setLoading(false);
                }
            });
    }

    const getAgentData = () => {
        get('AgentCalls', `GetAgentDetails`, (data) => {
            const newCallTableViewModel = { ...callTableViewModel };
            newCallTableViewModel.filters.operationsFilters.isActive = true;
            newCallTableViewModel.filters.client = data.client;
            newCallTableViewModel.filters.operationsFilters.agentName = [{ name: data.name, payrollNumber: data.payrollNumber }];

            setCallTableViewModel({
                ...newCallTableViewModel
            });
        });
    }

    const handleChangePage = (event: unknown, newPage: number) => {
        let newCallTableViewModel = { ...callTableViewModel };
        newCallTableViewModel.filters.pageNumber = newPage;
        setCallTableViewModel({
            ...newCallTableViewModel
        });
        filterSearch(newCallTableViewModel)
    }

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        let newCallTableViewModel = { ...callTableViewModel };
        newCallTableViewModel.filters.pageNumber = 0;
        newCallTableViewModel.filters.rowsPerPage = parseInt(event.target.value, 10)

        setCallTableViewModel({
            ...newCallTableViewModel
        });
        filterSearch(newCallTableViewModel)
    }

    const setFeedbackCount = (count: number) => {
        setFeedback(count);
    }

    const getFeedbackCount = () => {
        get('Feedback', `GetAgentsFeedbackCount`, (data) => {
            setFeedback(data)
        });
    }

    const getFirstCall = () => {
        setFindingCall(true);
        get('Feedback', `GetCall?customerId=${props.customerId}&result=${props.callRefId}&date=${props.date}`, (data) => {
            setFindingCall(false);
            setCallRefId(data);
        });
    }

    const updateStateFilters = (newCallTableViewModel: CallTableViewModel, applyFilters: boolean = false) => {
        setCallTableViewModel(newCallTableViewModel);

        if (!applyFilters) {
            setShowAlert(true);
            return;
        }
        filterSearchPageReset()
        setShowAlert(false);
    }

    const handleFirestoneFeedbackClose = (customerId: string, date: Date) => {
        const newCallTableViewModel = { ...callTableViewModel }
        newCallTableViewModel.filters.customerFilters.isActive
        newCallTableViewModel.filters.customerFilters.customerID = customerId
        newCallTableViewModel.filters.dateTimeFilters.preset = 'Single Date'
        newCallTableViewModel.filters.dateTimeFilters.startDate = date
        newCallTableViewModel.filters.dateTimeFilters.endDate = date

        setCallTableViewModel({
            ...newCallTableViewModel
        });
        setCallRefId(null);
    }

    const handleCallRef = (callRefId: string) => {
        setCallRefId(callRefId);
    }

    const handleFeedbackClose = () => {
        setCallRefId(null)
    }

    const closeFailedModal = () => {
        setSearchFailed(false);
    }

    return (
        <Box style={{ height: '100%' }} display="flex" flexDirection="column">
            <>
                <Stack direction="row">
                    {tabs.map((tab, i) => (
                        <Button
                            key={tab.id}
                            fullWidth
                            onClick={() => setIndex(tab.id)}
                            sx={index === tab.id ? styles.selectedTab : styles.tab}
                            style={index !== tab.id && i !== tabs.length - 1 && i !== index - 1 ? { borderRight: '1px white solid' } : {}}
                        >
                            {tab.id === 1 && <AssessmentIcon />}
                            {tab.id === 3 && <AssessmentIcon />}
                            {tab.name}
                            {tab.id === 2 &&
                                <Chip label={feedback}
                                    sx={index === 2 ? { color: "black", marginLeft: '4px' } : { color: "white", marginLeft: '4px' }}

                                />
                            }
                        </Button>
                    ))}
                </Stack>
            </>
            {
                !findingCall &&
                <Paper sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    flexGrow: 1,
                    borderRight: 'solid 1px black',
                    borderLeft: 'solid 1px black',
                    borderBottom: 'solid 1px black',
                }}>
                    {index !== 2 &&
                        <>
                            <FilterBar
                                client={callTableViewModel.filters.client ?? ''}
                                updateFilters={updateStateFilters}
                                callTableViewModel={callTableViewModel}
                                setCallTableViewModel={setCallTableViewModel}
                                loaded={false}
                                isRTM={false}
                                isClient={false}
                                readonly={false}
                                rowsCount={callTableViewModel.filters.count}
                                similarWords={[]}
                                isAgent
                                isReport={index !== 0}
                                showDownloadButton={false} />
                        </>
                    }
                    {tabs[index].name === 'My Calls' &&
                        <>
                            {showAlert &&
                                <Alert severity="info">After selecting your filters, be sure to click "Apply Filters" to view your results.</Alert>
                            }
                            <AgentViewContainer callRefId={callRefId} loading={loading} data={data} searchFailed={searchFailed} handleCallRef={handleCallRef} closeFailedModal={closeFailedModal} handleFeedbackClose={handleFeedbackClose} handleFirestoneFeedbackClose={handleFirestoneFeedbackClose} handleChangePage={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} />
                        </>
                    }
                    {tabs[index].name === 'Q-AI Report' &&
                        <Grid size={12} justifyContent='center'>
                            <Button
                                style={{ display: 'block', margin: 'auto' }}
                                variant="contained"
                                size="small"
                                onClick={() => setOpenChallengeDialog(true)}
                            >
                                Challenge Q-AI
                            </Button>
                        </Grid>
                    }
                    <Dialog open={openChallengeDialog} maxWidth="lg" fullWidth>
                        <DialogTitle>Challenge question</DialogTitle>
                        <ChallengeQuestionContainer view={UserType.Agent} setOpenChallengeDialog={setOpenChallengeDialog} />
                    </Dialog>
                    {/*dont use index here, it causes re-renders*/}
                    <ReportContainer todayReportId={tabs[1].todayGuid} historicReportId={tabs[1].historicGuid} filters={callTableViewModel} isAgentView isSelected={tabs[index].name === 'Q-AI Report'} />
                    <div style={{ display: index === 2 ? 'contents' : 'none' }}>
                        <AgentFeedbackContainer setFeedback={setFeedbackCount} />
                    </div>
                    <ReportContainer todayReportId={tabs[3].todayGuid} historicReportId={tabs[3].historicGuid} filters={callTableViewModel} isAgentView isSelected={tabs[index].name === 'Sales-AI Report'} />
                </Paper>
            }
        </Box>
    );
}